import React from 'react';

const DynamicHTMLRenderer = (content) => {
	return (
		<div
			className="event-pera"
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	);
};

export default DynamicHTMLRenderer;
